/**
 * Handles the logic for our static page headers.
 * 
 * @export
 * @class PageHeader
 */
import imagesLoaded from 'imagesloaded';

export class PageHeader {
    public container: Element;

    /**
     * Sets our properties and executes some methods.
     * 
     * @param container The root header element.
     */
    constructor(container: Element) {
        this.container = container;

        this.transitionIn();
    }


    /**
     * Add's a class when the background image has loaded so that we can add a nice transition effect.
     * 
     * @memberof PageHeader
     */
    transitionIn(): void {
        imagesLoaded(this.container, { background: '.js-page-header__bg' }).on('progress', () => {
            this.container.classList.add('c-page-header--has-loaded');
        });
    }
}
